<template>
    <div>
        <div class="border border-dark rounded-8 p-3">
            <h3 class="text-secondary fw-bold ff-sora">Actualmente tienes el plan: {{ licence.name }}</h3>
            <hr>
            <h4 class="text-primary">Consumo de tu plan:</h4>

            <div class="row my-3 consumoplan mx-0 p-0 rounded align-items-center border-0 bg-white">
                <div class="col-6 col-md-6 fs-5 py-1 pe-4">
                    <div class="d-flex gap-2 text-primary fw-500 justify-content-center align-items-center fs-4 flex-column-reverse flex-lg-row">
                        <div class="fs-2">{{client.estudiantes}} de {{ licence.accepted_users }}</div>
                        <img src="/img/icono/grupo.svg" class="ms-3" alt="" width="35px">
                    </div>
                    <div class="d-flex justify-content-center">
                        <p class="text-left text-dark lh-1">Usuarios inscritos en tu plan</p>
                    </div>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-4" style="display: none;">
                    <div class="d-flex gap-2 text-primary fw-500 justify-content-center align-items-center fs-4 flex-column-reverse flex-lg-row">
                        <div class="fs-2">{{client.rutas}} de {{ licence.accepted_routes }}</div>
                        <img src="/img/icono/ruta.svg" class="ms-3" alt="" width="35px">
                    </div>
                    <p class="text-left text-dark lh-1">Rutas inscritas en tu plan</p>
                </div>
                <div class="col-6 col-md-3 fs-5 py-1 px-4" style="display: none;">
                    <div class="d-flex gap-2 text-primary fw-500 justify-content-center align-items-center fs-4 flex-column-reverse flex-lg-row">
                        <div class="fs-2">{{client.cursos}} de {{ licence.accepted_courses }}</div>
                        <img src="/img/icono/libro.svg" class="ms-3" alt="" width="35px">
                    </div>
                    <p class="text-left text-dark lh-1">Cursos agregados en tu plan</p>
                </div>
                <div class="col-6 col-md-6 fs-5 py-1 ps-4">
                    <div class="d-flex gap-2 text-primary fw-500 justify-content-center align-items-center fs-4 flex-column-reverse flex-lg-row">
                        <div class="fs-2">{{ this.datediff }}</div>
                        <img src="/img/icono/calendario.svg" class="ms-3" alt="" width="35px">
                    </div>
                    <div class="d-flex justify-content-center">
                        <p class="text-left text-dark lh-1">Restantes de tu plan actual</p>
                    </div>
                </div>
            </div>

            <div class="rounded-8 overflow-hidden mx-3" style="display:none">
                <img src="/img/planes/up-to-premium-ilimitado.jpg" alt="" class="img-fluid">
            </div>

            <div class="text-center my-3">
                <a href="https://wa.me/+5215592522981" target="_blank" class="bg-green w-auto py-2 px-5 text-light fs-3 fw-500 rounded-8 ff-sora">
                    Hablar con un Asesor
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["licenciacliente", "datediff",'clientdata'],
    data() {
        return {
            licence: this.licenciacliente,
            client: this.clientdata
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(){
            console.log(this.client);
            console.log(this.licence);
        }
    },
};
</script>
